import { useMutation, useQuery } from "@tanstack/react-query";
import api from "../axios-client";
import { queryClient } from "../query-client";

export const useGetGeofences = (deviceId: string) => {
    return useQuery({
        queryKey: ["devices", deviceId, "geofences"],
        queryFn: async () => {
            const response = await api.get(`/api/v1/devices/${deviceId}/geofences`);
            return response.data.data;
        },
        retry: false,
    });
};

export const useCreateGeofence = () =>
    useMutation({
        mutationFn: async ({ deviceId, data }: { deviceId: string; data: any }) => {
            const response = await api.post(`/api/v1/devices/${deviceId}/geofences`, data);
            return response.data.data;
        },
        onSuccess: (_, { deviceId }) => {
            queryClient.refetchQueries({
                queryKey: ["devices", deviceId, "geofences"],
            });
        },
    });

export const useUpdateGeofence = () =>
    useMutation({
        mutationFn: async ({ deviceId, geofenceId, data }: { deviceId: string; geofenceId: string; data: any }) => {
            const response = await api.put(`/api/v1/devices/${deviceId}/geofences/${geofenceId}`, data);
            return response.data.data;
        },
        onSuccess: (_, { deviceId }) => {
            queryClient.refetchQueries({
                queryKey: ["devices", deviceId, "geofences"],
            });
        },
    });

export const useDeleteGeofence = () =>
    useMutation({
        mutationFn: async ({ deviceId, geofenceId }: { deviceId: string; geofenceId: string }) => {
            const response = await api.delete(`/api/v1/devices/${deviceId}/geofences/${geofenceId}`);
            return response.data.data;
        },
        onSuccess: (_, { deviceId }) => {
            queryClient.refetchQueries({
                queryKey: ["devices", deviceId, "geofences"],
            });
        },
    });

export const useGetGeofenceEvents = (deviceId: string) => {
    return useQuery({
        queryKey: ["devices", deviceId, "geofences", "events"],
        queryFn: async () => {
            const response = await api.get(`/api/v1/devices/${deviceId}/geofences/events`);
            return response.data.data;
        },
        retry: false,
    });
};

export const useGetGeofenceEligibleUsers = (deviceId: string) => {
    return useQuery({
        queryKey: ["devices", deviceId, "geofences", "eligible-users"],
        queryFn: async () => {
            const response = await api.get(`/api/v1/devices/${deviceId}/geofences/eligible-users`);
            return response.data.data;
        },
        retry: false,
        staleTime: 1000 * 60 * 5,
    });
};
